import { render, staticRenderFns } from "./AlbumPicker.vue?vue&type=template&id=4057f57f&scoped=true&"
import script from "./AlbumPicker.vue?vue&type=script&lang=js&"
export * from "./AlbumPicker.vue?vue&type=script&lang=js&"
import style0 from "./AlbumPicker.vue?vue&type=style&index=0&id=4057f57f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4057f57f",
  null
  
)

export default component.exports